// extracted by mini-css-extract-plugin
export default {"select":"FYOqi","md":"mb_1l","option":"Zjwbw","optionIcon":"ZCgHy","optionText":"Jb1UA","lg":"pVu0I"};